import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import ActivityCard from "@/components/app/ActivityCard";
import { Zap, BadgeCheck } from "lucide-react";
import { toast } from "sonner";
import { useTranslation } from "react-i18next";

export default function Spontaneous() {
  const { t } = useTranslation();
  const { user, refresh } = useAuth();
  const [data, setData] = useState({ activities: [], ready_users: [] });

  const load = async () => {
    const { data } = await api.get("/activities/spontaneous");
    setData(data);
  };
  useEffect(() => { load(); }, []);

  const toggleReady = async () => {
    await api.post("/users/me/spontaneous", { is_ready: !user?.is_ready_now });
    toast.success(!user?.is_ready_now ? t("spontaneous.youReReady") : t("spontaneous.standDown"));
    await refresh();
    load();
  };

  return (
    <div className="max-w-5xl mx-auto px-4 sm:px-6 pt-6 pb-32">
      <div className="card-nb p-6 mb-6 bg-[#F9C349]" data-testid="spontaneous-hero">
        <div className="flex items-start justify-between gap-3 flex-wrap">
          <div>
            <h1 className="font-display font-black text-4xl sm:text-5xl leading-none">{t("spontaneous.title")}</h1>
            <p className="mt-2 text-[#121212]">{t("spontaneous.subtitle")}</p>
          </div>
          <button onClick={toggleReady} className={`btn-nb ${user?.is_ready_now ? "btn-nb-dark" : "btn-nb-primary"} text-base shrink-0`} data-testid="ready-toggle">
            <Zap className="w-5 h-5" strokeWidth={3}/> {user?.is_ready_now ? t("spontaneous.ready") : t("spontaneous.imReadyNow")}
          </button>
        </div>
      </div>

      <h2 className="font-display font-black text-xl mb-3">{t("spontaneous.happeningSoon")}</h2>
      {data.activities.length === 0 ? (
        <p className="card-nb p-6 bg-white mb-6">{t("spontaneous.nothing6h")} <Link to="/create" className="underline font-bold">{t("spontaneous.createOne")}</Link>.</p>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 mb-8">
          {data.activities.map((a, i) => <ActivityCard key={a.id} activity={a} idx={i}/>)}
        </div>
      )}

      <h2 className="font-display font-black text-xl mb-3">{t("spontaneous.buddiesReady", { n: data.ready_users.length })}</h2>
      {data.ready_users.length === 0 ? (
        <p className="text-[#4A4A4A]">{t("spontaneous.nobody")}</p>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
          {data.ready_users.map((u) => (
            <Link to={`/u/${u.id}`} key={u.id} data-testid={`ready-user-${u.id}`} className="card-nb p-4 flex items-center gap-3 bg-[#E2F3E4]">
              <div className="w-12 h-12 rounded-full bg-white border-2 border-[#121212] flex items-center justify-center font-display font-black overflow-hidden">
                {u.avatar_url ? <img src={u.avatar_url} alt="" className="w-full h-full object-cover"/> : u.name?.[0]?.toUpperCase()}
              </div>
              <div className="flex-1 min-w-0">
                <div className="font-display font-bold truncate flex items-center gap-1">{u.name} {u.verified && <BadgeCheck className="w-4 h-4 text-[#00B4D8]" strokeWidth={3}/>}</div>
                <div className="text-xs text-[#4A4A4A] truncate">{u.location || "—"} · {u.energy_level || "balanced"}</div>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
